export default {
  title: 'Earn Points & Get Rewards',
  header: {
    pickup: 'Pickup in 5 Minutes',
  },
  recommendations: {
    title: 'Recommended',
  },
  discounts: {
    title: 'Discounts',
    data: [
      {
        title: '+125 Extra Points',
        description: 'Rate us on Google',
      },
      {
        title: '+{{amount}} Discount',
        description: '+{{amount}} Discount when you pay with the code {{code}}',
      },
    ],
    button: {
      add: '+ Add',
    },
  },
  rewards: {
    title: 'Rewards & Coupons',
    balance: 'Balance',
    points: 'Points',
  },
};
